import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import { store } from "./store";
import "./assets/css/tailwind.css";
import "./assets/css/input.css";
import "./assets/css/comic-builder.css";

// Toast
import { ToastService } from '@/modules/common/services/toast.service';
import 'vue-toastification/dist/index.css';
import Toast, { POSITION } from 'vue-toastification';
const options = {
    position: POSITION.TOP_CENTER
};
export const toast = new ToastService();
import { createPinia } from 'pinia';
const pinia = createPinia();


const app = createApp(App)
    .use(router)
    .use(store)
    .use(pinia)
    .use(Toast, options);
app.mount('#app');

